import { PublisherAdContainer } from '../ads/PublisherAdContainer'
import { chatLogger } from '../../utils/logger'

// Utility function for className merging
function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ')
}

interface AdMessageProps {
  className?: string
}

export function AdMessage({ className }: AdMessageProps) {
  return (
    <div className={cn("flex flex-col items-center mb-6 w-full", className)}>
      <PublisherAdContainer 
        idPrefix="kwry-chat-ad"
        className="max-w-md"
      />
    </div>
  )
}